import { useTranslation } from 'react-i18next'

import styles from '../CandidateDetailsContainer.module.scss'
import { SubmissionDetailsSection } from '../components/submissionDetailsSection/SubmissionDetailsSection'

import { CandidateApplicationCardProps } from './CandidateApplicationCard.types'
import { CardContent, CardDashboard, Flex } from '@percent/lemonade'

export function CandidateApplicationCard({ application }: Readonly<CandidateApplicationCardProps>) {
  const { t } = useTranslation()

  const details = application?.details ?? []

  const organisationContactName = `${application.organisationContact?.firstName} ${application.organisationContact?.lastName}`

  return (
    <Flex direction="column" data-testid="candidate-application-card" className={styles.cardCtn} gap={16}>
      <CardDashboard title={t('grants.application.title')} data-testid="application">
        <CardContent title={t('grants.application.fullName')} testId="applicant-full-name">
          {organisationContactName}
        </CardContent>
        <CardContent title={t('grants.application.email')} testId="applicant-email">
          <a href={`mailto:${application?.organisationContact?.email}`}>{application?.organisationContact?.email}</a>
        </CardContent>
        <SubmissionDetailsSection details={details} dataTestId="application-details" />
      </CardDashboard>
    </Flex>
  )
}
